import SlackNotificationModal from './SlackNotificationModal';

export default SlackNotificationModal;
